import PropTypes from "prop-types";
import React, { useState } from "react";
import {first, isArray} from "lodash";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const FocusedInputField = ({
  input,
  type,
  meta,
  hintText,
  id,
  rows,
  disabled,
  dataTest,
  containerClassName
}) => {
  const [showPassword, setShowPassword] = useState(false);
  // we will display the error message, only if
  // the field has been edited to a new value

  // If you want to change whether or not the hint text will eternally float above the field
  // without requiring focus or an an event to fill the field then set the floating attribute of Textfield to true
  // as described here: https://react-md.mlaursen.com/components/text-fields?tab=1#text-field-proptypes-floating
  
  const isInvalidate = meta.touched && meta.error && !!meta.error.length;
  const errorMessage = isInvalidate
    ? (isArray(meta.error) ? first(meta.error) : meta.error)
    : "";
  
  const isPasswordField = type === "password";
  const inputType = isPasswordField ? (showPassword ? "text" : "password") : type;

  return (
    <div className={`input-field-wrapper ${containerClassName}`}>
      <TextField
        {...input}
        value={input.value}
        multiline={rows ? true : false}
        rows={rows}
        type={inputType}
        label={hintText}
        id={id}
        disabled={disabled}
        inputProps={{ "data-test": dataTest }}
        fullWidth
        variant="standard"
        error={isInvalidate}
        InputProps={isPasswordField ? {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={() => setShowPassword(!showPassword)}
                edge="end"
                size="small"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          )
        } : undefined}
      />
      <div className="validation-error" 
        data-test={`${dataTest}-error`}>
          {errorMessage}
      </div>
    </div>
  );
};

FocusedInputField.propTypes = {
  input: PropTypes.object.isRequired,
  type: PropTypes.string,
  meta: PropTypes.object.isRequired,
  hintText: PropTypes.string,
  id: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  dataTest: PropTypes.string,
  rows: PropTypes.number,
  containerClassName: PropTypes.string
};

export default FocusedInputField;

